var app = angular.module("leonardo");

var TaskPriorityDialog = function($scope, $rootScope, TemplateService, AccountUserService, FormErrorsService,
                                  PortfolioService, PropertyService) {

  $scope.task = $scope.ngDialogData.task;
  $scope.template = $scope.ngDialogData.template;
  $scope.work_order = $scope.ngDialogData.work_order;

  $scope.portfolio = '';
  if ($scope.template && $scope.template.portfolio) {
    $scope.portfolio = $scope.template.portfolio;
  }
  else {
    $scope.portfolio = $scope.ngDialogData.portfolio ? $scope.ngDialogData.portfolio : '';
  }

  $scope.property = '';
  if ($scope.template && $scope.template.property) {
    $scope.property = $scope.template.property;
  }
  else {
    $scope.property = $scope.ngDialogData.property ? $scope.ngDialogData.property : '';
  }

  $scope.priorityOptions = angular.copy(TemplateService.PRIORITY_OPTIONS);
  $scope.templateService = TemplateService;

  $scope.portfolios = [];
  $scope.properties = [];

  $scope.getPortfolios = function() {
    if (angular.isArray($scope.portfolio)) {
      return $scope.portfolio;
    }
    else {
      if (!isNull($scope.portfolio)) {
        return angular.isString($scope.portfolio) ? $scope.portfolio.split(',') : [$scope.portfolio];
      }
      else {
        return [];
      }
    }
  };

  $scope.getProperties = function() {
    if (angular.isArray($scope.property)) {
      return $scope.property;
    }
    else {
      if (!isNull($scope.property)) {
        return angular.isString($scope.property) ? $scope.property.split(',') : [$scope.property];
      }
      else {
        return [];
      }
    }
  };

  $scope.portfolios = !isEmpty($scope.getPortfolios()) ?
    PortfolioService.getlist({disable_pagination:true, essential:true, id:$scope.getPortfolios()}) : null;
  $scope.properties = !isEmpty($scope.getProperties()) ?
    PropertyService.getlist({disable_pagination:true, essential:true, id:$scope.getProperties()}): null;

  if ($scope.work_order) {
    $scope.data = {
      priority: $scope.work_order.priority.toString()
    };
  }
  else if ($scope.task) {
    $scope.data = {
      priority: $scope.task.priority.toString()
    };
  }
  else if ($scope.template) {
    $scope.data = {
      priority: $scope.template.priority.toString()
    };
  }

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var portfolios = !isNull($scope.properties_data) && !isEmpty($scope.properties_data.portfolios) ?
      $scope.properties_data.portfolios : [];
    var properties = !isNull($scope.properties_data) && !isEmpty($scope.properties_data.properties) ?
      $scope.properties_data.properties : [];
    if ($scope.template) {
      $scope.template.setPriority({
        priority: $scope.data.priority,
        portfolios: portfolios,
        properties: properties
      }).then(function(result) {
        $rootScope.$broadcast('task-priority-dialog:success', result);
        $scope.closeThisDialog();
      });
    }
    else if ($scope.task) {
      $scope.task.setPriority({
        priority: $scope.data.priority,
        portfolios: portfolios,
        properties: properties
      }).then(function(result) {
        $rootScope.$broadcast('task-priority-dialog:success', result);
        $scope.closeThisDialog();
      });
    }
  };
};

app.controller('TaskPriorityDialog', ['$scope', '$rootScope', 'TemplateService', 'AccountUserService',
  'FormErrorsService', 'PortfolioService', 'PropertyService', TaskPriorityDialog]);
